import React from "react";
import { Col, Container, Card, Row } from "reactstrap";
import { Link } from "react-router-dom";

export default function Pricing() {
    const features = [
        "Accès illimité à toutes les fonctionnalités",
        "Aucune carte bancaire requise",
        "Stockage sécurisé inclus",
        "Mises à jour gratuites",
        "Support réactif par email",
    ];

    return (
        <>
            <section className="section bg-light" id="pricing">
                <Container>
                    <Row className="justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title fw-semibold mb-4">Tarification</h4>
                                <p className="para-desc text-muted mx-auto mb-0">
                                    Profitez de toutes les fonctionnalités gratuitement. Pas de frais cachés, pas de plans payants.
                                </p>
                            </div>
                        </div>
                    </Row>

                    <Row className="justify-content-center">
                        <Col lg={6} md={8} className="col-12 mt-4 pt-2">
                            <Card className="border-0 shadow">
                                <div className="p-4 border-bottom border-light text-center">
                                    <h6 className="fw-semibold mb-3 text-uppercase">Gratuit</h6>
                                    <p className="text-muted mb-0">Une solution simple et complète, accessible à tous</p>

                                    <div className="d-flex justify-content-center my-4">
                                        <span className="price h3 fw-semibold mb-0">0€</span>
                                        <span className="text-muted align-self-end mb-1">/mois</span>
                                    </div>

                                    <Link to="#" className="btn btn-primary w-100">Commencer maintenant</Link>
                                </div>

                                <div className="p-4">
                                    <h6 className="mb-3">Fonctionnalités incluses :</h6>
                                    <ul className="mb-0 list-unstyled">
                                        {features.map((feature, index) => (
                                            <li className="text-muted" key={index}>
                                                <span className="text-success h5 me-1">
                                                    <i className="uil uil-check-circle align-middle"></i>
                                                </span>
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <div className="col text-center mt-4">
                            <p className="text-muted">
                                <span className="text-success fw-bold">* </span>
                                Tous les services sont 100% gratuits. Aucune carte bancaire nécessaire.
                            </p>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    );
}
